import React, { useEffect, useState } from "react";
import NavbarAndSidebarLayout from "~/layouts/NavbarAndSidebarLayout";
import useRequest from "~/common/hooks/useRequest";
import { API_STATE } from "~/common/constants/state";
import "~/assets/sass/pages/dashboard/dashboard.scss";

//components
import Info from "./Info";
import Portfolio from "./Portfolio";
import Invest from "./Invest";
import Round from "./Round";
import Company from "./Company";
import Apply from "./Apply";
import Alarm from "./Alarm";

const DashboardPage = () => {
	const dashBoardApi = useRequest("get", "vc/user/dashboard");
	const [dashboardData, setDashboardData] = useState({});
	const checkAuth = dashboardData.user?.role;
	const authPlugins = dashboardData.userInfo?.authPlugins.map((auth) => auth.title);

	useEffect(() => {
		dashBoardApi.call({}, "body");
	}, []);

	useEffect(() => {
		switch (dashBoardApi.state) {
			case API_STATE.done:
				setDashboardData(dashBoardApi.response.data);
				break;
			case API_STATE.error:
				console.log("error", dashBoardApi.error);
				break;
			default:
				break;
		}
	}, [dashBoardApi.state]);

	return (
		<>
			<NavbarAndSidebarLayout menu={["dashboard"]} type="main">
				<div className="dashboard-wrap">
					<div className="item-wrap">
						<Info userList={dashboardData.user} userInfoList={dashboardData.userInfo} />
						<Portfolio
							portfolioList={dashboardData.portfolioSummary}
							checkAuth={checkAuth}
							authPlugins={authPlugins}
						/>
					</div>
					<div className="item-wrap">
						<Invest
							investList={dashboardData.invests}
							checkAuth={checkAuth}
							authPlugins={authPlugins}
						/>
						<Round
							roundList={dashboardData.rounds}
							checkAuth={checkAuth}
							authPlugins={authPlugins}
						/>
						<Apply
							applyList={dashboardData.applies}
							checkAuth={checkAuth}
							authPlugins={authPlugins}
						/>
					</div>
					<div className="item-wrap">
						<Company dashboardData={dashboardData} />
						<Alarm alarmList={dashboardData.alarmList} />
					</div>
				</div>
			</NavbarAndSidebarLayout>
		</>
	);
};

export default DashboardPage;
